<section
  *ngFor="let offer of offers; let isFirst = first; let isLast = last"
  class="offer-collection flex lg:min-h-offer-collection offer-collection--selected"
  [class.mt-3]="!isFirst"
  [class.offer-collection--selected]="isSelected(offer)"
>
  <app-form-radio-button
    class="flex p-3 bg-vtmn-play-content-brand bg-opacity-5 items-center"
    #controlChild
    [required]="true"
    [formControl]="offersForm"
    name="offer"
    [htmlValue]="offer"
    (click)="handleClickOnFormulaForMobile()"
  ></app-form-radio-button>

  <article class="px-4 py-3 text-left">
    <h3 class="font-bold mb-2">
      {{ offer.name }}
    </h3>

    <p
      class="text-vtmn-play-content-quiet text-xs font-medium mb-2"
      [innerHtml]="offer.description | stripHtml | nl2br"
    ></p>

    <div class="flex flex-wrap flex-col">
      <app-badge [variant]="badgeVariant.YELLOW">
        {{ offer.price | displayPrice: offer.currency }}
      </app-badge>
      <app-badge *ngIf="isBg" [variant]="badgeVariant.YELLOW">
        {{ offer.price | priceConversion | displayPrice: '€' }}
      </app-badge>
      <app-badge
        class="my-2 ml-2"
        [variant]="badgeVariant.BORDER_GREY"
        *ngIf="showExternalPaymentBadge"
      >
        {{ 'timeslot.selection.allow_external_payment' | translate }}
      </app-badge>
    </div>
  </article>
</section>
